import { FolderPlus, UserPlus, UsersRound } from "lucide-react";
import { MmcFrame } from "../../admin-framework/MmcFrame.js";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

export function DirectoryUsersComputersApp({ activeMachine, app, onRunCommand }: SimulatorAppSurfaceProps) {
  const run = (commandType: string, capability: string, label: string, payload: Record<string, unknown>) => {
    void onRunCommand({ appId: app.id, capability, commandType, label, payload: { machineId: activeMachine, ...payload } });
  };

  return (
    <div className="fd-sim-app fd-sim-admin-tool">
      <MmcFrame
        title={app.title}
        actions={[
          { label: "New OU", onClick: () => run("SERVER_CREATE_OU", "domainOu.write", "New OU", { ouName: "ServiceDesk", parentOuName: "Users" }) },
          { label: "New User", onClick: () => run("SERVER_CREATE_DOMAIN_USER", "domainUsers.write", "New User", { displayName: "Selina Ticket 166", ouName: "Users", samAccountName: "selina.166", username: "selina.166" }) },
          { label: "New Group", onClick: () => run("SERVER_CREATE_DOMAIN_GROUP", "domainGroups.write", "New Group", { groupName: "Support-Team", ouName: "Users", scope: "global", type: "security" }) },
          { label: "Add Member", onClick: () => run("SERVER_ADD_DOMAIN_GROUP_MEMBER", "domainGroups.write", "Add Member", { groupName: "Support-Team", username: "selina.166" }) }
        ]}
        columns={[
          { key: "name", label: "Name" },
          { key: "type", label: "Type" },
          { key: "container", label: "Container" }
        ]}
        rows={[
          { id: "user-selina", values: { name: "selina.166", type: "User", container: "Users" }, onDoubleClick: () => run("SERVER_CREATE_DOMAIN_USER", "domainUsers.write", "New User", { displayName: "Selina Ticket 166", ouName: "Users", samAccountName: "selina.166", username: "selina.166" }) },
          { id: "group-support", values: { name: "Support-Team", type: "Security Group", container: "Users" }, onDoubleClick: () => run("SERVER_CREATE_DOMAIN_GROUP", "domainGroups.write", "New Group", { groupName: "Support-Team", ouName: "Users", scope: "global", type: "security" }) },
          { id: "ou-servicedesk", values: { name: "ServiceDesk", type: "Organizational Unit", container: "Domain" }, onDoubleClick: () => run("SERVER_CREATE_OU", "domainOu.write", "New OU", { ouName: "ServiceDesk", parentOuName: "Users" }) }
        ]}
        tree={[
          { active: true, id: "domain", icon: <UsersRound size={16} />, label: "advanced-ti.local" },
          { id: "builtin", icon: <FolderPlus size={16} />, label: "Builtin" },
          { active: true, id: "users", icon: <UserPlus size={16} />, label: "Users" },
          { id: "servicedesk", icon: <FolderPlus size={16} />, label: "ServiceDesk" }
        ]}
      >
        <section className="fd-mmc-property-band">
          <button type="button" onClick={() => run("SERVER_SET_DOMAIN_USER_STATE", "domainUsers.state.write", "Enable User", { enabled: true, username: "selina.166" })}>Enable account</button>
          <button type="button" onClick={() => run("SERVER_RESET_DOMAIN_USER_PASSWORD", "domainUsers.password.write", "Reset password", { mustChangePassword: true, username: "selina.166" })}>Reset password</button>
        </section>
      </MmcFrame>
    </div>
  );
}
